/* eslint-disable react/jsx-props-no-spreading */
import { SVGProps } from 'react';

const LineChartBox = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={30}
    height={25}
    viewBox="0 0 30 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="LineChartBox">
    <ellipse cx={23.956} cy={6.045} rx={5.043} ry={5.045} stroke="currentColor" />
    <path
      transform="rotate(-45.052 18.644 -22.63)"
      stroke="currentColor"
      d="M.706 0h2.786v2.786H.706z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.581 4.79H4a4 4 0 0 0-4 4V21a4 4 0 0 0 4 4h17.217a4 4 0 0 0 4-4v-7.462a7.258 7.258 0 0 1-1.5.172V21a2.5 2.5 0 0 1-2.5 2.5H4A2.5 2.5 0 0 1 1.5 21V8.79A2.5 2.5 0 0 1 4 6.29h12.393c.011-.516.075-1.017.188-1.5Z"
      fill="currentColor"
    />
    <path
      d="m3.765 15.309 2.791 2.553 3.544-4.868 5.679 6.327 3.86-6.682"
      stroke="var(--brand-bg-primary)"
      strokeWidth={1.8}
    />
  </svg>
);

export default LineChartBox;
